/**
 * 消費税
 */
export class Tax {
    /** 消費税ID */
    id = 0
    /** 適用開始日 */
    startOn = ""
    /** 税率(%) */
    taxRate = 0.0

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<Tax>) {
        Object.assign(this, init)
    }
}
